export default "__VITE_ASSET__kss3Rvxv__"